import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form, Button, Col, Row, Modal } from "react-bootstrap";
import "./SettingsPage.css";

const SettingsPage = () => {
  const { t, i18n } = useTranslation();

  const [settings, setSettings] = useState({
    site_name: "",
    site_description: "",
    email: "",
    phone: "",
    address: "",
    telebirr_payment_details: "",
    cbe_payment_details: "",
    banks: [
      { name: "commercial Bank", account: "" },
     
    ]
  });

  const [showModal, setShowModal] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState("");

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch("https://agpipefitting.org.et/api/settings");

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        setSettings({
          ...data,
          banks: data.banks || [
            { name: "commercial Bank", account: "" },
           
          ]
        });

        i18n.changeLanguage(data.language || "en");
      } catch (error) {
        console.error("Error fetching settings:", error);
        alert("Failed to fetch settings. Please check the server connection.");
      }
    };

    fetchSettings();
  }, [i18n]);

  const handleSaveSettings = async () => {
    try {
      const response = await fetch("https://agpipefitting.org.et/api/settings", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json", // Ensure Accept header is set
        },
        body: JSON.stringify(settings),
      });

      const result = await response.json();

      if (response.ok) {
        setConfirmationMessage(t("successMessage"));
        setShowModal(true);
      } else {
        console.error('Backend error:', result.error);
        setConfirmationMessage(result.message || t("errorMessage"));
        setShowModal(true);
      }
    } catch (error) {
      console.error('Network error:', error);
      setConfirmationMessage(t("errorMessage"));
      setShowModal(true);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "language") {
      i18n.changeLanguage(value); // Change system language
    }

    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: value,
    }));
  };

  const handleBankInputChange = (e, index) => {
    const { name, value } = e.target;
    const updatedBanks = [...settings.banks];
    updatedBanks[index][name] = value;

    setSettings((prevSettings) => ({
      ...prevSettings,
      banks: updatedBanks
    }));
  };

  const handleAddBank = () => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      banks: [...prevSettings.banks, { name: "", account: "" }]
    }));
  };

  const handleRemoveBank = (index) => {
    const updatedBanks = settings.banks.filter((_, i) => i !== index);
    setSettings((prevSettings) => ({
      ...prevSettings,
      banks: updatedBanks
    }));
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="settings-page">
      <div className="page-header">
        <h1>{t("Settings Update")}</h1>
      </div>

      <div className="settings-form">
        <Form>
          <Row>
            <Col sm={12} md={6}>
              <Form.Group controlId="siteName">
                <Form.Label>{t("siteName")}</Form.Label>
                <Form.Control
                  type="text"
                  name="site_name"
                  value={settings.site_name}
                  onChange={handleInputChange}
                  placeholder={t("Enter site name")}
                />
              </Form.Group>
            </Col>
            <Col sm={12} md={6}>
              <Form.Group controlId="siteDescription">
                <Form.Label>{t("siteDescription")}</Form.Label>
                <Form.Control
                  as="textarea"
                  name="site_description"
                  value={settings.site_description}
                  onChange={handleInputChange}
                  placeholder={t("Enter site description")}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={6}>
              <Form.Group controlId="email">
                <Form.Label>{t("contactEmail")}</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={settings.email}
                  onChange={handleInputChange}
                  placeholder={t("Enter contact email")}
                />
              </Form.Group>
            </Col>
            <Col sm={12} md={6}>
              <Form.Group controlId="phone">
                <Form.Label>{t("contactPhone")}</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  value={settings.phone}
                  onChange={handleInputChange}
                  placeholder={t("Enter contact phone")}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={6}>
              <Form.Group controlId="address">
                <Form.Label>{t("siteAddress")}</Form.Label>
                <Form.Control
                  type="text"
                  name="address"
                  value={settings.address}
                  onChange={handleInputChange}
                  placeholder={t("Enter site address")}
                />
              </Form.Group>
            </Col>
          </Row>

          {/* Payment Details Section - Multiple Banks */}
          {settings.banks.map((bank, index) => (
            <Row key={index}>
              <Col sm={12} md={4}>
                <Form.Group controlId={`bankName${index}`}>
                  <Form.Label>{t("bankName")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={bank.name}
                    onChange={(e) => handleBankInputChange(e, index)}
                    placeholder={t("Enter bank name")}
                  />
                </Form.Group>
              </Col>
              <Col sm={12} md={4}>
                <Form.Group controlId={`bankAccount${index}`}>
                  <Form.Label>{t("bankAccount")}</Form.Label>
                  <Form.Control
                    type="text"
                    name="account"
                    value={bank.account}
                    onChange={(e) => handleBankInputChange(e, index)}
                    placeholder={t("Enter bank account number")}
                  />
                </Form.Group>
              </Col>
              <Col sm={12} md={4}>
                <Button variant="danger" onClick={() => handleRemoveBank(index)}>
                  {t("removeBank")}
                </Button>
              </Col>
            </Row>
          ))}

          <Button variant="success" onClick={handleAddBank}>
            {t("addBank")}
          </Button>

          <Button variant="primary" onClick={handleSaveSettings}>
            {t("saveSettings")}
          </Button>
        </Form>
      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{t("settingsUpdate")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{confirmationMessage}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SettingsPage;
